import { api } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type { CreditAccount } from '../models/credit.types';

export function getCredits(): Promise<CreditAccount> {
  return api().get<CreditAccount>(ENDPOINTS.me.credits);
}
